module.exports = __webpack_public_path__ + "static/media/rolling-mill-transparent.5474658a.png";